import { useEffect, useState } from "react";
import { verifyResponse } from "../API/ApiService"
import { useSearchParams } from "react-router-dom";


export default function VerifyComponent() {

    const [success, setSuccess] = useState("loading");
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");


    useEffect(() => { 
        async function waitForVerification() {
            try {
                const response = await verifyResponse(token);
                if(response.status==200) {
                    // 1 = good, 2 = used, 3 = expired, 4 = exception
                    if(response.data==1) {
                setSuccess("Success")}
                else if (response.data==2) {
                    setSuccess("ErrorUsed")
                } else if (response.data===3) {
                    setSuccess("ErrorExpired")
                }
            } else {setSuccess("Error")}
            } catch(e) {setSuccess("Error")}
        } if (token) {
            waitForVerification()
        } else {setSuccess("No token")}
    }, [token]);


    if (success === "loading") {
        return <div className="verifypage">
                <div className="verifytitle">Verifying...</div></div> }
    if (success === "Success") {
        return <div className="verifypage">
                <div className="verifytitle">Verification successful.</div></div>}

    if (token && success === "ErrorUsed") {

    return (
        <div className="verifypage">
            <div className="verifytitle">User has already been verified.</div>           
        </div>
    )
    }

        if (token && success === "ErrorExpired") {

    return (
        <div className="verifypage">
            <div className="verifytitle">Verification token is expired (they expire after 24 hours).</div>            
        </div>
    )
    }

    if (token && success === "Error") {

    return (
        <div className="verifypage">
            <div className="verifytitle">You've reached a working link but an error is preventing the page from checking verification status.
                 Please report the error using the contact link in the top right.</div>       
        </div>
    )
    }

    if (!token) {
        return (
            <div className="verifypage">
                <div className="verifytitle">                
                This page needs a verification token in order to work. Check your email for a link containing a "token=?text" string at the end.
                </div>
            </div>
        )
    }
    


}


